import m from "mithril";
import {record, Replayer} from "rrweb";
import lf from "localforage";
import pf from "../../pf";
import lzwCompress from "lzwcompress";
import {ulid} from "ulid";

const recorderfunction = () => {
	const eventstore = lf.createInstance({name: "prasora-recorder-eventstore"});
	let index = 0;
	let recording = false;
	let uid = undefined;
	const recordkey = "prasora-rrweb-recording-key";
	let stopfunction = undefined;

	function SaveEvent(event) {
		index++;
	}

	function RunRecorder() {
		recording = true;
		uid = ulid();
		lf.setItem(recordkey, uid);

		stopfunction = record({
			emit(event) {
				SaveEvent(event);
			},
		});
		return uid;
	}

	function Compress(events) {
		return lzwCompress.pack(JSON.stringify(events));
	}

	function StopRecorder() {
		lf.removeItem(recordkey);
		recording = false;
		if (stopfunction) {
			stopfunction();
			stopfunction = undefined;
			index = 0;
		}
	}

	return {
		uid: () => {
			return uid;
		},
		recording: () => {
			return recording;
		},
		start: () => {
			return RunRecorder();
		},
		end: () => {
			return StopRecorder();
		},
		restartifrequired: () => {
			lf.getItem(recordkey).then((r) => {
				if (r) {
					uid = r;
					RunRecorder();
				}
			});
		},
	};
};

const recorder = recorderfunction();
recorder.restartifrequired();

export default recorder;

function download(content, fileName, contentType) {
	var a = document.createElement("a");
	var file = new Blob([content], {type: contentType});
	a.href = URL.createObjectURL(file);
	a.download = fileName;
	a.click();
}
